
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import {
  ListTile,
  RoundIcon,
  Category,
  Icon,
  Margin,
  Size,
  Avatar,
  Text,
  Color,
} from '@drawbotics/react-drylus';
import Playground from '~/components/Playground';


const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


<h1>{`List Tile`}</h1>
<p>{`Inspired by the Flutter `}<a parentName="p" {...{
        "href": "https://api.flutter.dev/flutter/material/ListTile-class.html"
      }}>{`component`}</a>{` of the same name.`}</p>
<pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`import { ListTile } from '@drawbotics/react-drylus';
`}</code></pre>
<p><strong parentName="p">{`Example`}</strong></p>
<Playground __position={0} __code={`<ListTile
  title="Hello"
  subtitle="Im the subtitle"
  leading={<RoundIcon name="check" size={50} />}
  onClick={x=>x} />`} component={ListTile} mdxType="Playground">
  <ListTile title="Hello" subtitle="Im the subtitle" leading={<RoundIcon name="check" size={50} mdxType="RoundIcon" />} onClick={x => x} mdxType="ListTile" />
</Playground>
<p>{`The same component can be used for many things, such as combining an icon, or an avatar with text:`}</p>
<Playground __position={1} __code={`<>
  <Margin size={{ bottom: Size.EXTRA_SMALL }}>
    <ListTile title="Destructive action" leading={<Icon name="x" color={Color.RED} />} />
  </Margin>
  <Margin size={{ bottom: Size.EXTRA_LARGE }}>
    <ListTile title="Success action" leading={<Icon name="check" color={Color.GREEN} />} />
  </Margin>
  <ListTile title="Mr Man Boy" leading={<Avatar text="mb" color={Color.GREEN} />} />
</>`} mdxType="Playground">
  <>
    <Margin size={{
          bottom: Size.EXTRA_SMALL
        }} mdxType="Margin">
      <ListTile title="Destructive action" leading={<Icon name="x" color={Color.RED} mdxType="Icon" />} mdxType="ListTile" />
    </Margin>
    <Margin size={{
          bottom: Size.EXTRA_LARGE
        }} mdxType="Margin">
      <ListTile title="Success action" leading={<Icon name="check" color={Color.GREEN} mdxType="Icon" />} mdxType="ListTile" />
    </Margin>
    <ListTile title="Mr Man Boy" leading={<Avatar text="mb" color={Color.GREEN} mdxType="Avatar" />} mdxType="ListTile" />
  </>
</Playground>
<p>{`You can use a custom Text component to change the look of the text for the `}<inlineCode parentName="p">{`ListTile`}</inlineCode>{` `}<inlineCode parentName="p">{`title`}</inlineCode>{` and `}<inlineCode parentName="p">{`subtitle`}</inlineCode>{` properties:`}</p>
<Playground __position={2} __code={`<ListTile title={<Text bold>Custom text</Text>} subtitle={<Text category={Category.DANGER}>Same</Text>} leading={<RoundIcon name="check" size={50} />} />`} mdxType="Playground">
  <ListTile title={<Text bold mdxType="Text">Custom text</Text>} subtitle={<Text category={Category.DANGER} mdxType="Text">Same</Text>} leading={<RoundIcon name="check" size={50} mdxType="RoundIcon" />} mdxType="ListTile" />
</Playground>
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;